<template>
<div>

<div v-html="welcometext"></div>
<div class="flex align-items-center justify-content-center pb-6 pt-2" v-if="$store.state.evaluation.evaluation">



<Button :label="$store.state.languages.lang_phrases.basla" v-if="$store.state.evaluation.evaluation.status=='created'" class="p-button-outlined p-button-primary p-button-lg"  icon="pi pi-check" @click="startFlow"/>


<Button :label="$store.state.languages.lang_phrases.basla" v-if="$store.state.evaluation.evaluation.status=='viewed'" class="p-button-outlined p-button-primary p-button-lg"  icon="pi pi-check" @click="startFlow"/>

<Button :label="$store.state.languages.lang_phrases.devam_et" v-if="$store.state.evaluation.evaluation.status=='started'" class="p-button-outlined p-button-primary p-button-lg"  icon="pi pi-check" @click="startFlow"/>


<Button :label="$store.state.languages.lang_phrases.goruntule" v-if="$store.state.evaluation.evaluation.status=='finished'" class="p-button-outlined p-button-primary p-button-lg"  icon="pi pi-check" @click="startFlow"/>
</div>


</div>
</template>

<script>
export default {

  name: 'EvaluationInfo',

  data () {
    return {
    	data:null,
    }
  },
   mounted()
  {
  	this.getData()
  },
  computed:{
  	welcometext()
  	{
  		let preflang = this.$store.state.auth.user.preflang
  		if(this.$store.state.evaluation.evaluation)
  		{
  			let text = this.$store.state.evaluation.evaluation.flow.translations.find((item)=>{return item.language_id == preflang.id})
  			return text.description
  		}

  		return ""
  	}
  },
  methods:{
  	async getData()
  	{
  		this.data = await this.generalApiGet("audit/"+this.$route.params.id) 

  		await this.$store.dispatch('evaluation/setEvaluation',this.data) 
      	console.log(this.data);
  	},
  	startFlow()
  	{
  		let flow = this.$store.state.evaluation.evaluation.flow

  		if(flow.type=="education")
  		{
  			this.gotoPage("EvaluationEducation")
  		}
  		if(flow.type=="self_evaluation")
  		{
  			this.gotoPage("EvaluationProgress")
  		}
  		if(flow.type=="verification")
  		{
  			this.gotoPage("EvaluationProgress")
  		}
  	}
  	
  }
};
</script>

<style lang="css" scoped>
</style>